import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../components/common/ProtectedRoute";
import DashboardLayout from "../components/layout/DashboardLayout";
import { DepartmentCode, PositionCode, UserRole } from "../enum/roles";
import Blocked from "../pages/Blocked/Blocked";
import Dashboard from "../pages/Dashboard/Dashboard";
import Forbidden from "../pages/Forbidden/Forbidden";
import PartNumberHistory from "../pages/History/PartNumberHistory";
import Home from "../pages/Home/Home";
import Login from "../pages/Login/Login";
import Shipments from "../pages/Logistics/Shipments";
import Tracking from "../pages/Logistics/Tracking";
import TrackingList from "../pages/Logistics/TrackingList";
import NotFound from "../pages/NotFound/NotFound";
import Timesheet from "../pages/Production/Timesheet";
import Profile from "../pages/Profile/Profile";
import ProjectDetail from "../pages/ResearchDevelopment/ProjectDetail";
import ProjectList from "../pages/ResearchDevelopment/ProjectList";
import AccountSystem from "../pages/Setting/AccountSystem";
import DepartmentSystem from "../pages/Setting/DepartmentSystem";
import PermissionSystem from "../pages/Setting/PermissionSystem";
import Warehouse from "../pages/Warehouses/Warehouse";
import WarehouseExportOptions from "../pages/Warehouses/WarehouseExportOptions";
import WarehouseInEx from "../pages/Warehouses/WarehouseInExList";
import WarehouseIssue from "../pages/QualityControl/QualityControlResult";
import WarehouseLocation from "../pages/Warehouses/WarehouseLocation";
import PurchaseRequest from "../pages/Purchase/PurchaseRequest";
import PurchaseRequestDetail from "../pages/Purchase/PurchaseRequestDetail";
import AwbManage from "../pages/Logistics/AwbManage";
import PurchaseRequestAssign from "../pages/Purchase/PurchaseRequestAssign";
import PurchaseReceiptCreate from "../pages/Purchase/PurchaseReceiptCreate";
import PurchaseReceipt from "../pages/Purchase/PurchaseReceipt";
import PurchaseOrder from "../pages/Purchase/PurchaseOrder";
import PurchaseOrderDetail from "../pages/Purchase/PurchaseOrderDetail";
import Document from "../pages/Document/Document";
import ProductionProjects from "../pages/Production/ProductionProjects";
import ProductionProjectDetail from "../pages/Production/ProductionProjectDetail";
import Customers from "../pages/Sales/Customers";
import Contacts from "../pages/Sales/Contacts";
import SupplierLogistics from "../pages/Logistics/SupplierLogistics";
import PurchaseSupplier from "../pages/Purchase/PurchaseSupplier";
import QualityControlRequest from "../pages/QualityControl/QualityControlRequest";
import QualityControlRequestDetail from "../pages/QualityControl/QualityControlRequestDetail";
import QualityControlResultDetail from "../pages/QualityControl/QualityControlResultDetail";
import QualityControlReturn from "../pages/QualityControl/QualityControlReturn";
import QualityControlResultByAwb from "../pages/QualityControl/QualityControlResultByAwb";
import { HrmEmployee } from "../pages/Hrm/HrmEmployee";
import { HrmLeaveRequests } from "../pages/Hrm/HrmLeaveRequests";
import { HrmOvertimeRequests } from "../pages/Hrm/HrmOvertimeRequests";
import HrmEmployeeDetail from "../pages/Hrm/HrmEmployeeDetail";
import { PersonalLeaveRequests } from "../pages/Personal/PersonalLeaveRequests";
import { PersonalOvertimeRequests } from "../pages/Personal/PersonalOvertimeRequests";
import HrmEmployeeInfo from "../pages/Hrm/HrmEmployeeInfo";
import HrmStationery from "../pages/Hrm/HrmStationeryPeriod";
import HrmStationeryDetail from "../pages/Hrm/HrmStationeryRequest";
import HrmStationeryItems from "../pages/Hrm/HrmStationeryRequestItem";
import Personal from "../pages/Personal/Personal";
import PersonalAttendance from "../pages/Personal/PersonalAttendance";
import PersonalStationery from "../pages/Personal/PersonalStationery";
import PersonalStationeryDetail from "../pages/Personal/PersonalStationeryDetail";
import ManagerOvertimeRequest from "../pages/Personal/PersonalOvertimeApproval";
import ManagerLeaveRequests from "../pages/Personal/PersonalLeaveApproval";
import HrmStationeryProduct from "../pages/Hrm/HrmStationeryProduct";
import HrmMeetingSchedule from "../pages/Hrm/HrmMeetingSchedule";
import PersonalMeetingSchedule from "../pages/Personal/PersonalMeetingSchedule";
import HrmMeetingRoom from "../pages/Hrm/HrmMeetingRoom";
import HrmStationeryCategory from "../pages/Hrm/HrmStationeryCategory";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/not-found" element={<NotFound />} />
      <Route path="/forbidden" element={<Forbidden />} />
      <Route path="/blocked" element={<Blocked />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
      </Route>
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Profile />} />
      </Route>

      <Route path="/setting" element={<DashboardLayout />}>
        <Route
          path="accounts"
          element={
            <ProtectedRoute roles={[UserRole.SUPER_ADMIN]}>
              <AccountSystem />
            </ProtectedRoute>
          }
        />
        <Route
          path="permissions"
          element={
            <ProtectedRoute roles={[UserRole.SUPER_ADMIN]}>
              <PermissionSystem />
            </ProtectedRoute>
          }
        />{" "}
        <Route
          path="departments"
          element={
            <ProtectedRoute roles={[UserRole.SUPER_ADMIN]}>
              <DepartmentSystem />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/warehouse"
        element={
          <ProtectedRoute
            roles={[UserRole.ADMIN, UserRole.STAFF]}
            departments={[DepartmentCode.WH]}
          >
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Warehouse />} />
        <Route path="exports" element={<WarehouseExportOptions />} />
        <Route path="list-ex-im" element={<WarehouseInEx />} />
        <Route path="locations" element={<WarehouseLocation />} />
      </Route>

      <Route
        path="/hrm"
        element={
          <ProtectedRoute
            departments={[DepartmentCode.HR]}
            roles={[UserRole.ADMIN, UserRole.STAFF]}
          >
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="employee" element={<HrmEmployee />} />
        <Route path="leave-requests" element={<HrmLeaveRequests />} />
        <Route path="overtime-requests" element={<HrmOvertimeRequests />} />
        <Route path="employee/:alias" element={<HrmEmployeeDetail />} />
        <Route path="employee/info/:alias" element={<HrmEmployeeInfo />} />
        <Route path="stationerys" element={<HrmStationery />} />
        <Route path="stationerys/:alias" element={<HrmStationeryDetail />} />
        <Route path="meeting-schedules" element={<HrmMeetingSchedule />} />
        <Route path="meeting-rooms" element={<HrmMeetingRoom />} />
        <Route path="meeting-schedules/:alias" />
        <Route
          path="stationery-requests/:requestId"
          element={<HrmStationeryItems />}
        />
        <Route path="stationerys/products" element={<HrmStationeryProduct />} />
        <Route
          path="stationerys/categories"
          element={<HrmStationeryCategory />}
        />
      </Route>
      <Route
        path="/personal"
        element={
          <ProtectedRoute roles={[UserRole.ADMIN, UserRole.STAFF]}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Personal />} />
        <Route path="my-attendance" element={<PersonalAttendance />} />
        <Route path="me/leave-requests" element={<PersonalLeaveRequests />} />
        <Route
          path="my-overtime-requests"
          element={<PersonalOvertimeRequests />}
        />
        <Route path="me/stationery" element={<PersonalStationery />} />
        <Route
          path="me/stationery/:alias"
          element={<PersonalStationeryDetail />}
        />
        <Route
          path="my-meeting-schedules"
          element={<PersonalMeetingSchedule />}
        />
        <Route
          path="overtime-requests"
          element={
            <ProtectedRoute positions={[PositionCode.MANAGER]}>
              <ManagerOvertimeRequest />
            </ProtectedRoute>
          }
        />
        <Route
          path="leave-requests"
          element={
            <ProtectedRoute positions={[PositionCode.MANAGER]}>
              <ManagerLeaveRequests />{" "}
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/quality-control"
        element={
          <ProtectedRoute
            roles={[UserRole.ADMIN, UserRole.STAFF]}
            departments={[DepartmentCode.QC]}
          >
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="qc-issues" element={<WarehouseIssue />} />
        <Route path="qc-issues/:id" element={<QualityControlResultDetail />} />
        <Route path="qc-requests" element={<QualityControlRequest />} />
        <Route
          path="qc-requests/:id"
          element={<QualityControlRequestDetail />}
        />
        <Route path="returns" element={<QualityControlReturn />} />
        <Route path="returns/:id" element={<QualityControlResultByAwb />} />
      </Route>

      <Route
        path="/logistics"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="tracking" element={<Tracking />} />
        <Route path="tracking-list" element={<TrackingList />} />
        <Route
          path="customs-clearance"
          element={
            <ProtectedRoute
              roles={[UserRole.ADMIN, UserRole.STAFF]}
              departments={[DepartmentCode.LOG]}
            >
              <Shipments />
            </ProtectedRoute>
          }
        />
        <Route
          path="import-taxes"
          element={
            <ProtectedRoute
              roles={[UserRole.ADMIN, UserRole.STAFF]}
              departments={[DepartmentCode.LOG]}
            >
              <SupplierLogistics />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route
        path="/awbs"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AwbManage />} />
      </Route>

      <Route
        path="/history"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="part-number" element={<PartNumberHistory />} />
      </Route>
      <Route
        path="/production"
        element={
          <ProtectedRoute
            roles={[UserRole.ADMIN, UserRole.STAFF]}
            departments={[DepartmentCode.PD]}
          >
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="timesheet" element={<Timesheet />} />
        <Route path="project" element={<ProductionProjects />} />

        <Route path="project/:alias" element={<ProductionProjectDetail />} />
      </Route>
      <Route
        path="/r&d"
        element={
          <ProtectedRoute
            roles={[UserRole.ADMIN, UserRole.STAFF]}
            departments={[DepartmentCode.RND]}
          >
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="projects" element={<ProjectList />} />
        <Route path="projects/:alias" element={<ProjectDetail />} />
      </Route>
      <Route
        path="/purchase"
        element={
          <ProtectedRoute
            roles={[UserRole.ADMIN, UserRole.STAFF]}
            departments={[DepartmentCode.PUR]}
          >
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="suppliers" element={<PurchaseSupplier />} />
        <Route path="create-receipt" element={<PurchaseReceiptCreate />} />
        <Route
          path="requests"
          element={
            <ProtectedRoute
              positions={[PositionCode.PUR_MANAGER, PositionCode.PUR_LEADER]}
            >
              <PurchaseRequest />
            </ProtectedRoute>
          }
        />
        <Route path="request-assign" element={<PurchaseRequestAssign />} />
        <Route path="requests/:alias" element={<PurchaseRequestDetail />} />
        <Route path="receipts" element={<PurchaseReceipt />} />
        <Route path="orders" element={<PurchaseOrder />} />
        <Route path="orders/:alias" element={<PurchaseOrderDetail />} />
      </Route>

      <Route
        path="/sales"
        element={
          <ProtectedRoute roles={[UserRole.ADMIN, UserRole.STAFF]}>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="customers" element={<Customers />} />
        <Route path="contacts" element={<Contacts />} />
      </Route>

      <Route path="/form" element={<DashboardLayout />}>
        <Route index element={<Document />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
